
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundNo as ObiSoundNoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-no.js';
 
 
 

 
 export const ObiSoundNo = createComponent({
   react: React,
   tagName: 'obi-sound-no',
   elementClass: ObiSoundNoElement,
   events: {
     
   }
  });
 
 